import { SpeciesDto } from '@/Application/Batch/Species/SpeciesDto'
import { Batch } from '@/Domain/Batch'
import { BatchDtoJson } from './BatchDtoJson'

export class BatchDto {
  private _batchId: string
  private _recordId: string
  private _batchType: string
  private _uneCertification: boolean
  private _fscCertification: boolean
  private _mount: string
  private _owner: string
  private _county: string
  private _surface: string
  private _appraisal: string
  private _taxes: string
  private _temporaryDeposit: string
  private _window: number
  private _situationCode: number
  private _purposeCode: number
  private _volumeUnit: string
  private _alreadyWithOfferFlag : boolean
  private _species: SpeciesDto[]

  static fromJSON (jsonObject: BatchDtoJson): BatchDto {
    const speciesDto: SpeciesDto[] = []
    for (const species of jsonObject.species) {
      speciesDto.push(SpeciesDto.fromJSON(species))
    }
    return new this(
      jsonObject.batchId,
      jsonObject.recordId,
      jsonObject.batchType,
      jsonObject.uneCertification,
      jsonObject.fscCertification,
      jsonObject.mount,
      jsonObject.owner,
      jsonObject.county,
      jsonObject.surface,
      jsonObject.appraisal,
      jsonObject.taxes,
      jsonObject.temporaryDeposit,
      jsonObject.window,
      jsonObject.situationCode,
      jsonObject.purposeCode,
      jsonObject.volumeUnit,
      jsonObject.alreadyWithOfferFlag,
      speciesDto
    )
  }

  static fromBatch (batch: Batch): BatchDto {
    const speciesDto: SpeciesDto[] = []
    for (const species of batch.species()) {
      speciesDto.push(SpeciesDto.fromSpecies(species))
    }
    return new this(
      batch.batchId(),
      batch.recordId(),
      batch.batchType() as string,
      batch.uneCertification(),
      batch.fscCertification(),
      batch.mount(),
      batch.owner(),
      batch.county(),
      batch.surface(),
      batch.appraisal(),
      batch.taxes(),
      batch.temporaryDeposit(),
      batch.window(),
      batch.situation() as number,
      batch.purpose() as number,
      batch.volumeUnit(),
      batch.alreadyWithOfferFlag(),
      speciesDto
    )
  }

  constructor (
    batchId: string,
    recordId: string,
    batchType: string,
    uneCertification: boolean,
    fscCertification: boolean,
    mount: string,
    owner: string,
    county: string,
    surface: string,
    appraisal: string,
    taxes: string,
    temporaryDeposit: string,
    window: number,
    situationCode: number,
    purposeCode: number,
    volumeUnit: string,
    alreadyWithOfferFlag: boolean,
    species: SpeciesDto[]
  ) {
    this._batchId = batchId
    this._recordId = recordId
    this._batchType = batchType
    this._uneCertification = uneCertification
    this._fscCertification = fscCertification
    this._mount = mount
    this._owner = owner
    this._county = county
    this._surface = surface
    this._appraisal = appraisal
    this._taxes = taxes
    this._temporaryDeposit = temporaryDeposit
    this._window = window
    this._situationCode = situationCode
    this._purposeCode = purposeCode
    this._volumeUnit = volumeUnit
    this._alreadyWithOfferFlag = alreadyWithOfferFlag
    this._species = species
  }

  get batchId (): string {
    return this._batchId
  }

  get recordId (): string {
    return this._recordId
  }

  get batchType (): string {
    return this._batchType
  }

  get uneCertification (): boolean {
    return this._uneCertification
  }

  get fscCertification (): boolean {
    return this._fscCertification
  }

  get mount (): string {
    return this._mount
  }

  get owner (): string {
    return this._owner
  }

  get county (): string {
    return this._county
  }

  get surface (): string {
    return this._surface
  }

  get appraisal (): string {
    return this._appraisal
  }

  get taxes (): string {
    return this._taxes
  }

  get temporaryDeposit (): string {
    return this._temporaryDeposit
  }

  get window (): number {
    return this._window
  }

  get situationCode (): number {
    return this._situationCode
  }

  get purposeCode (): number {
    return this._purposeCode
  }

  get volumeUnit (): string {
    return this._volumeUnit
  }

  get alreadyWithOfferFlag (): boolean {
    return this._alreadyWithOfferFlag
  }

  get species (): SpeciesDto[] {
    return this._species
  }

  toJSON (): BatchDtoJson {
    const speciesJson = this._species.map(current => current.toJSON())
    return {
      batchId: this._batchId,
      recordId: this._recordId,
      batchType: this._batchType,
      uneCertification: this._uneCertification,
      fscCertification: this._fscCertification,
      mount: this._mount,
      owner: this._owner,
      county: this._county,
      surface: this._surface,
      appraisal: this._appraisal,
      taxes: this._taxes,
      temporaryDeposit: this._temporaryDeposit,
      window: this._window,
      situationCode: this._situationCode,
      purposeCode: this._purposeCode,
      alreadyWithOfferFlag: this._alreadyWithOfferFlag,
      volumeUnit: this._volumeUnit,
      species: speciesJson
    }
  }
}
